var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFacebookColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_facebook-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD365",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC023",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1327.000000, -48.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(1147.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(180.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 C34.1505994,0 44,9.84940057 44,22 C44,34.1505994 34.1505994,44 22,44 C9.84940057,44 0,34.1505994 0,22 C0,9.84940057 9.84940057,0 22,0 Z M27.0858439,9.09322944 C21.8149586,9.09322944 18.7251319,11.8764831 18.7251319,18.2181878 L18.7251319,22.0481739 L13.3064342,22.0481739 L13.3064342,27.8051981 L18.724035,27.8051981 L18.724035,43.6287989 C19.7970453,43.7886564 20.8842883,43.8981461 21.9999969,43.8981461 C23.0084067,43.8981461 23.9927294,43.8061739 24.9639103,43.674785 L24.9639133,27.8041042 L30.6311531,27.8041042 L31.5213128,22.04708 L24.9639133,22.04708 L24.9639133,18.9003161 C24.9639133,16.5090383 25.7456772,14.3882017 27.9825731,14.3882017 L31.5771531,14.3882017 L31.5771531,9.3647675 C30.9453925,9.27936472 29.6096044,9.09322944 27.0858439,9.09322944 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookColor);
export default __webpack_public_path__ + "static/media/ic_facebook-color.61f90c26899ec621461d5a01d025344b.svg";
export { ForwardRef as ReactComponent };